// Converts HEX to RGBA
function hexToRgba(hex, alpha = 1) {
    const bigint = parseInt(hex?.replace("#", ""), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// Lightens a color by percentage
function lightenColor(hex, percent) {
    const num = parseInt(hex?.replace("#", ""), 16);
    let r = (num >> 16) + Math.round(255 * percent);
    let g = ((num >> 8) & 0x00FF) + Math.round(255 * percent);
    let b = (num & 0x0000FF) + Math.round(255 * percent);

    r = Math.min(255, r);
    g = Math.min(255, g);
    b = Math.min(255, b);

    return `rgba(${r}, ${g}, ${b}, 1)`;
}

// Generates gradient
export const generateGradient = (mainHexColor = "#a8c738") => {
    const base = hexToRgba(mainHexColor);
    const lighter = lightenColor(mainHexColor, 0.15); // 15% lighter
    return `linear-gradient(360deg, ${base} 0%, ${base} 0%, ${lighter} 100%)`;
}
